import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Modal } from 'antd';
import Swal from 'sweetalert2';
import YouTube from 'react-youtube';
import { db } from '../Firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import './SpacialExecries.css';
import countdownSound1 from '../Components/assets/countdown1.mp3';
import countdownSound2 from '../Components/assets/countdown2.mp3';
import countdownSound3 from '../Components/assets/countdown3.mp3';
import correctSound from '../Components/assets/true.wav';
import wrongSound from '../Components/assets/wrong.wav';
import titleSound from './Title-Sound.wav';

  const SILVER_VIDEO_LIST = [
    "2dtiwXldCWA", "KHk2M2RIjeg", "KukCZ6YnbsM", "kntxPzgL4C8", "RqkGDbCQDh4", "DB3COAu3R60", "oeE8ZwDfSIw", "qPwZx-KkfKs", 
    "9wjXYc-12Eg", "SLkA12u8ZAc", "bvC2CILyJSI", "OnbtlcCAP8s", "ITH64WUW8VQ", "-uXtcSd_-uY", "HhokIYw53ic", "rtknU_P_3R8", "hXZ0uuB-zbE", "j6X21_mKtNk", 
    "9wjXYc-12Eg", "SLkA12u8ZAc", "bvC2CILyJSI", "OnbtlcCAP8s", "ITH64WUW8VQ", "-uXtcSd_-uY", "HhokIYw53ic", "rtknU_P_3R8", "hXZ0uuB-zbE", "j6X21_mKtNk"
    
  ];

  const SILVER_CORRECT_ANSWERS = {
    0: "37",  1: "85",  2: "30",  3: "84",  4: "42",  5: "52",  6: "23",  7: "47",  
   8: "13",  9: "85", 10: "95", 11: "87", 12: "27", 13: "79", 14: "89", 15: "98", 16: "81", 17: "28",
   18: "13",  19: "85", 20: "95", 21: "87", 22: "27", 23: "79", 24: "89", 25: "98", 26: "81", 27: "28"

  };

  const GOLD_VIDEO_LIST = [
    "Ne3h88sEbzM", "KL7PIikaQ78", "VEfPndw2cp8", "pSmg5BbkHpw", "VHvh1-Oo6Ok", "ZoHrz9bArV0", "07pNCuY69oU", "WcslZMyRbiw", 
    "AoiYMgqz3xM", "FmHyXr3mkNA", "dJ95POewFOU", "f_BJphnZiEo", "g-2nCbpotQQ", "Bs4Ewf1DTAE", "0KpHQv3En4s", "rM51Zozj7_A", "eNUV87zOxoE", "choXhU-81W4",
    "AoiYMgqz3xM", "FmHyXr3mkNA", "dJ95POewFOU", "f_BJphnZiEo", "g-2nCbpotQQ", "Bs4Ewf1DTAE", "0KpHQv3En4s", "rM51Zozj7_A", "eNUV87zOxoE", "choXhU-81W4"


  ];

  const GOLD_CORRECT_ANSWERS = {
    0: "39",  1: "82",  2: "50",  3: "18",  4: "32",  5: "36",  6: "69",  7: "55", 
   8: "71",  9: "17", 10: "13", 11: "64", 12: "56", 13: "48", 14: "91", 15: "81", 16: "81", 17: "22",
   18: "71",  19: "17", 20: "13", 21: "64", 22: "56", 23: "48", 24: "91", 25: "81", 26: "81", 27: "22"

  };

  const DIAMOND_VIDEO_LIST = [
    "syhrnV1lt_8", "DfJoiBgt-W4", "VJ2t-owpnPs", "oidXD1ZD7HU", "zkLkwAnjXGw", "aoomWSUOBvI", "JvO9bLxV6uw", "rVxmvwwfh0E", 
    "5LIMePlaXFk", "idnNTdxg7fA", "rpi59hmzNQk", "OMbMXvjUf-w", "UnojpnTHcS0", "UhngiO-yhW8", "acpHnleZhj8", "PNOxNFzjUgg", "ZNRQb0tJ_SU", "STHJdmeBMvE",
    "5LIMePlaXFk", "idnNTdxg7fA", "rpi59hmzNQk", "OMbMXvjUf-w", "UnojpnTHcS0", "UhngiO-yhW8", "acpHnleZhj8", "PNOxNFzjUgg", "ZNRQb0tJ_SU", "STHJdmeBMvE"

  ];

  const DIAMOND_CORRECT_ANSWERS = {
    0: "22",  1: "15",  2: "57",  3: "45",  4: "91",  5: "29",  6: "49",  7: "25", 
   8: "91",  9: "91", 10: "89", 11: "96", 12: "31", 13: "82", 14: "14", 15: "47", 16: "77", 17: "38",
 18: "91",  19: "91", 20: "89", 21: "96", 22: "31", 23: "82", 24: "14", 25: "47", 26: "77", 27: "38"

  };


const calculateScoreBasedOnTime = (timeRemainingSeconds, duration, currentState) => {
  const tier = timeRemainingSeconds / duration;
  
  // คะแนนเต็มตามระดับ
  let maxScore;
  if (currentState === 3) {
    maxScore = 150; // Diamond
  } else if (currentState === 2) {
    maxScore = 100; // Gold
  } else {
    maxScore = 50;  // Silver
  }
  
  return Math.round(tier * maxScore);
};

function SpacialExecries({ visible, onClose, userData, onUserUpdate }) {
  const location = useLocation();
  const playerRef = useRef(null);
  const videoTimerRef = useRef(null);
  const timerIntervalRef = useRef(null);
  const videoEndedRef = useRef(false);
  const [currentState, setCurrentState] = useState(1);
  const [showVideo, setShowVideo] = useState(false);
  const [isSoundPlaying, setIsSoundPlaying] = useState(false);
  const [soundVolume, setSoundVolume] = useState(0.5);
  const [informationShown, setInformationShown] = useState(false); // เพิ่ม state เพื่อป้องกันการแสดง information ซ้ำ

  useEffect(() => {
    const loadCurrentState = async () => {
      try {
        if (!userData?.username) return;
        const userRef = doc(db, "Competition-Training", userData.username);
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          const dbCurrentState = data['current-state'] || 1;
          setCurrentState(dbCurrentState);
        } else {
          setCurrentState(1);
        }
      } catch (error) {
        console.error("Error fetching current-state:", error);
        setCurrentState(1);
      }
    };
    loadCurrentState();
  }, [userData?.username]);

  const VIDEO_LIST = currentState === 3
    ? DIAMOND_VIDEO_LIST
    : currentState === 2
      ? GOLD_VIDEO_LIST
      : SILVER_VIDEO_LIST;

  const CORRECT_ANSWERS = currentState === 3
    ? DIAMOND_CORRECT_ANSWERS
    : currentState === 2
      ? GOLD_CORRECT_ANSWERS
      : SILVER_CORRECT_ANSWERS;

  const level = location.state?.level ?? userData?.['Spacial-Level'] ?? 0;
  const videoId = VIDEO_LIST[level] || VIDEO_LIST[0];
  
  const correctAudioRef = useRef(new Audio(correctSound));
  const wrongAudioRef = useRef(new Audio(wrongSound));
  const countdownAudioRef = useRef(null);
  const titleAudioRef = useRef(new Audio(titleSound));

  const playTitleSound = useCallback(() => {
    if (titleAudioRef.current) {
      titleAudioRef.current.currentTime = 0;
      titleAudioRef.current.volume = soundVolume;
      titleAudioRef.current.loop = true;
      titleAudioRef.current.play().catch(e => {
        console.error("Failed to play title sound:", e);
        // Retry with user interaction
        const retryPlay = () => {
          if (titleAudioRef.current) {
            titleAudioRef.current.play().catch(err => {
              console.error('Retry failed to play title sound:', err);
            });
          }
        };
        
        // Add event listeners for user interaction
        document.addEventListener('click', retryPlay, { once: true });
        document.addEventListener('keydown', retryPlay, { once: true });
        document.addEventListener('touchstart', retryPlay, { once: true });
      });
      setIsSoundPlaying(true);
    } else {
    }
  }, [soundVolume]);

  const stopTitleSound = useCallback(() => {
    if (titleAudioRef.current) {
      titleAudioRef.current.pause();
      titleAudioRef.current.currentTime = 0;
      setIsSoundPlaying(false);
    }
  }, []);

  // Function สำหรับ update Bonus-Spacial
  const updateBonusSpacial = useCallback(async () => {
    try {
      if (!userData?.username) {
        return;
      }

      const userRef = doc(db, "Competition-Training", userData.username);
      const docSnap = await getDoc(userRef);
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        const silverValue = data['show-silver'] || 0;
        const goldValue = data['show-gold'] || 0;
        const diamondValue = data['show-diamond'] || 0;
        const currentLevel = silverValue + goldValue + diamondValue;
        

        // Update Bonus-Spacial field
        await setDoc(userRef, {
          ...data,
          'Bonus-Spacial': currentLevel
        }, { merge: true });

        
        // ไม่เรียก onUserUpdate เพื่อป้องกันการ redirect ไปหน้า Login
        // if (onUserUpdate) {
        //   onUserUpdate();
        // }
      } else {
      }
    } catch (error) {
      console.error('❌ Error updating Bonus-Spacial:', error);
    }
  }, [userData]);

  const playCountdownSound = useCallback(() => {
    if (level <= 40) {
      countdownAudioRef.current = new Audio(countdownSound1);
    } else if (level <= 80) {
      countdownAudioRef.current = new Audio(countdownSound2);
    } else {
      countdownAudioRef.current = new Audio(countdownSound3);
    }
    
    if (countdownAudioRef.current) {
      countdownAudioRef.current.loop = true;
      countdownAudioRef.current.play().catch(e => console.error("Failed to play countdown sound:", e));
    }
  }, [level]);

  const stopCountdownSound = useCallback(() => {
    if (countdownAudioRef.current) {
      countdownAudioRef.current.pause();
      countdownAudioRef.current.currentTime = 0;
    }
  }, []);

  const showInformation = useCallback(() => {
    
    Swal.fire({
      title: 'Exercises Information',
      html: `
        <div style="text-align: center; margin-bottom: 20px;">
          <h3 style="color: #1890ff; margin-bottom: 15px;">🎯 ช่วงท้าทาย</h3>
          <div style="background: #f0f8ff; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
            <p><strong>ระดับ Silver:</strong> คะแนนเต็ม 50 คะแนน</p>
            <p><strong>ระดับ Gold:</strong> คะแนนเต็ม 100 คะแนน</p>
            <p><strong>ระดับ Diamond:</strong> คะแนนเต็ม 150 คะแนน</p>
          </div>
          <div style="background: #fff7e6; padding: 15px; border-radius: 8px;">
            <p><strong>วิธีการเล่น:</strong></p>
            <p>• ฟังโจทย์และหาคำตอบ</p>
            <p>• ตอบคำถามตามเวลาที่กำหนด</p>
            <p>• ยิ่งตอบเร็ว ยิ่งได้คะแนนมาก</p>
          </div>
        </div>
      `,
      //icon: 'info',
      showCancelButton: false,
      confirmButtonText: 'เริ่มเล่น',
      cancelButtonText: 'ปิด',
      confirmButtonColor: '#52c41a',
      cancelButtonColor: '#ff4d4f',
      width: '500px',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        playTitleSound();
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        // หยุดเสียง Title-Sound เมื่อกดเริ่มเล่น
        stopTitleSound();
        
        // Update Bonus-Spacial field
        await updateBonusSpacial();
        
        // ใช้ setTimeout เพื่อให้แน่ใจว่า SweetAlert ปิดแล้ว
        setTimeout(() => {
          setShowVideo(true);
          // Force re-render by calling a dummy function
        }, 1000);
      } else {
        // ถ้ากดปุ่มปิด ให้ปิด component และหยุดเสียง
        stopTitleSound();
        onClose();
      }
    });
  }, [onClose, playTitleSound, stopTitleSound, updateBonusSpacial]);

  // แสดง information เฉพาะเมื่อเปิด SpacialExecries (visible = true)
  useEffect(() => {
    if (visible && !informationShown) {
      // แสดง information เฉพาะเมื่อยังไม่แสดง
      setInformationShown(true); // ตั้งค่าว่าแสดงแล้ว
      showInformation();
    } else if (!visible) {
      // หยุดเสียงเมื่อปิด component และรีเซ็ต states ทั้งหมด
      setInformationShown(false); // รีเซ็ต informationShown
      setShowVideo(false); // รีเซ็ต showVideo
      stopTitleSound();
    }
  }, [visible, showInformation, stopTitleSound, informationShown]);


  const updateUserLevelAndScore = useCallback(async (scoreToAdd) => {
    if (!userData?.username) {
      return;
    }

    try {
      const userRef = doc(db, "Competition-Training", userData.username);
      const docSnap = await getDoc(userRef);

      let currentDbLevel = userData['Spacial-Level'] || 0;
      let currentDbScore = userData.score || 0;
      let currentBonus = userData.bonus || false;

      if (docSnap.exists()) {
        const dbData = docSnap.data();
        currentDbLevel = dbData['Spacial-Level'] || 0;
        currentDbScore = dbData.score || 0;
        currentBonus = dbData.bonus || false;
      }

      // เพิ่ม level เมื่อตอบถูก
      const newLevel = currentDbLevel + 1;
      const newScore = currentDbScore + scoreToAdd;
      let newBonus = currentBonus;

      // ตรวจสอบ bonus level จาก level ปัจจุบัน (ไม่ใช่จาก level ใหม่)
      const bonusLevels = [40, 80, 119];
      if (bonusLevels.includes(currentDbLevel)) {
        newBonus = true;
      }

      await setDoc(userRef, { 
        'Spacial-Level': newLevel, 
        score: newScore,
        bonus: newBonus
      }, { merge: true });
      
      // Debug: แสดงข้อมูลที่อัปเดต
      
      // ไม่เรียก onUserUpdate เพื่อป้องกันการ redirect ไปหน้า Login
      // onUserUpdate(userData.username);
    } catch (error) {
      console.error("Error updating user data in Firestore:", error);
      Swal.fire('เกิดข้อผิดพลาด', 'ไม่สามารถอัปเดตข้อมูลผู้ใช้ได้', 'error');
    }
  }, [userData]);

  const checkAnswer = useCallback(async (userAnswer, timeTaken, duration) => {
    stopCountdownSound();

    const correct = CORRECT_ANSWERS[level] === userAnswer;
    let scoreEarned = 0; 
    let message = '';
    let icon = 'error';

        if (correct) {
      const timeRemainingSecondsAtSubmit = (duration * 1000 - timeTaken) / 1000;
      scoreEarned = calculateScoreBasedOnTime(timeRemainingSecondsAtSubmit, duration, currentState);
      message = `ตอบถูก! คุณได้ ${scoreEarned} คะแนน`;
      correctAudioRef.current.play();
      icon = 'success';
    } else {
      scoreEarned = 0;
      message = `ตอบผิด! ลองใหม่อีกครั้ง`;
      wrongAudioRef.current.play();
      icon = 'error';
    }

    await Swal.fire({
      icon: icon,
      title: correct ? 'ถูกต้อง!' : 'ลองใหม่!',
      text: message,
      confirmButtonText: 'ตกลง'
    });

    await updateUserLevelAndScore(scoreEarned);
    onClose();
  }, [level, onClose, stopCountdownSound, updateUserLevelAndScore]);

  const showAnswerForm = useCallback(() => {
    stopCountdownSound();

    if (videoTimerRef.current) {
      clearTimeout(videoTimerRef.current);
    }

    if (timerIntervalRef.current) {
      clearInterval(timerIntervalRef.current);
    }

    if (playerRef.current && typeof playerRef.current.pauseVideo === 'function') {
      playerRef.current.pauseVideo();
    }

    let timerDuration;
    if (level <= 40) {
      timerDuration = 10;
    } else if (level <= 80) {
      timerDuration = 8;
    } else {
      timerDuration = 7;
    }

    let timer = timerDuration;
    let currentPossibleScore = calculateScoreBasedOnTime(timer, timerDuration, currentState);

    playCountdownSound();

    Swal.fire({
      title: 'ตอบคำถาม',
      html: `
        เหลือเวลา: <strong id="swal-countdown-timer" class="swal-big-text">${timer}</strong> วินาที<br>
        คะแนนที่จะได้: <span id="swal-possible-score" class="swal-big-text">${currentPossibleScore}</span> คะแนน<br>
        <input id="swal-input" class="swal2-input" placeholder="คำตอบของคุณ..." 
               type="number" inputmode="numeric" pattern="[0-9]*">
      `,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: false,
      confirmButtonText: 'ส่งคำตอบ',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      timer: timerDuration * 1000, // ตั้งค่า timer ให้ปิดอัตโนมัติ
      timerProgressBar: true, // แสดง progress bar
      
      didOpen: () => {
        const input = Swal.getPopup().querySelector('#swal-input');
        input.focus();
        const timerTextElement = Swal.getPopup().querySelector('#swal-countdown-timer');
        const possibleScoreElement = Swal.getPopup().querySelector('#swal-possible-score');
        
        input.addEventListener('keypress', (e) => {
          if (e.key === 'Enter') {
            Swal.clickConfirm();
          }
        });

        timerIntervalRef.current = setInterval(() => {
          timer--;
          if (timerTextElement) { 
              timerTextElement.textContent = timer;
          }
          
          currentPossibleScore = calculateScoreBasedOnTime(timer, timerDuration, currentState);
          if (possibleScoreElement) {
              possibleScoreElement.textContent = currentPossibleScore;
          }

          // เมื่อหมดเวลา ปิดกล่องและนำทางไปหน้า exercies
          if (timer <= 0) {
            clearInterval(timerIntervalRef.current);
            stopCountdownSound();
            
            // ปิดกล่อง SweetAlert2 และนำทางไปหน้า exercies
            Swal.close();
            onClose();
          }
        }, 1000);
      },
      preConfirm: () => {
        const answer = Swal.getPopup().querySelector('#swal-input').value;
        const timeRemaining = timer * 1000;
        const timeTaken = (timerDuration * 1000) - timeRemaining;
        return { 
          answer: answer, 
          timeTaken: timeTaken,
          duration: timerDuration
        };
      },
      willClose: () => {
        if (timerIntervalRef.current) {
          clearInterval(timerIntervalRef.current);
          timerIntervalRef.current = null;
        }
        stopCountdownSound();
      }
    }).then((result) => {
      // ตรวจสอบว่าปิดเพราะหมดเวลาหรือไม่
      if (result.dismiss === Swal.DismissReason.timer) {
        onClose();
      }
      // ตรวจสอบว่าผู้ใช้ส่งคำตอบ
      else if (result.isConfirmed) {
        checkAnswer(result.value.answer, result.value.timeTaken, result.value.duration);
      }
    });
  }, [checkAnswer, onClose, playCountdownSound, stopCountdownSound, playerRef, level]);

  const onPlayerReady = useCallback((event) => {
    playerRef.current = event.target;
    if (playerRef.current) {
      playerRef.current.playVideo();
    }

    videoTimerRef.current = setTimeout(() => {
      if (videoEndedRef.current) {
        return;
      }
      Swal.fire({
        icon: 'info',
        title: 'เวลาหมด',
        text: 'คุณต้องตอบคำถามเมื่อวิดีโอจบ',
        confirmButtonText: 'ตกลง',
      }).then(() => {
        onClose();
      });
    }, 30000);
  }, [onClose, videoEndedRef]);

  const onPlayerStateChange = useCallback((event) => {
    if (event.data === 0) { 
      videoEndedRef.current = true;

      if (videoTimerRef.current) {
        clearTimeout(videoTimerRef.current);
        videoTimerRef.current = null;
      }
      
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
      
      stopCountdownSound();
      showAnswerForm();
    }
  }, [showAnswerForm, stopCountdownSound]);

  // ป้องกันการใช้ ESC ปิดหน้า video
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && visible && showVideo) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    };

    if (visible && showVideo) {
      document.addEventListener('keydown', handleKeyDown, true);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [visible, showVideo]);

  useEffect(() => {
    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }
      if (videoTimerRef.current) {
        clearTimeout(videoTimerRef.current);
      }
      stopCountdownSound();
      stopTitleSound();

      if (correctAudioRef.current) {
        correctAudioRef.current.pause();
        correctAudioRef.current.currentTime = 0;
      }
      if (wrongAudioRef.current) {
        wrongAudioRef.current.pause();
        wrongAudioRef.current.currentTime = 0;
      }
      
      // Destroy YouTube player
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [stopCountdownSound, stopTitleSound]);

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 1,
      controls: 0,
      rel: 0,
      modestbranding: 1,
      fs: 1,
    },
  };

  if (!visible) return null;

  

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width="95vw"
      bodyStyle={{ padding: 0, height: '95vh' }}
      destroyOnClose
      centered
      className="video-modal spacial-exercises-modal"
      maskClosable={false}
      allowEscapeKey={false}
      //  title={`Spacial Exercises - ${currentState === 3 ? 'Diamond' : currentState === 2 ? 'Gold' : 'Silver'}`}
    >
      <div className="video-page-container spacial-video-container">
        {/* แสดง video เฉพาะเมื่อ showVideo = true */}
        {showVideo && (
          <div className="video-section spacial-video-section">
            {/* Video Container */}
            <div className="youtube-container spacial-youtube-container">
              <YouTube
                key={videoId}
                videoId={videoId}
                opts={opts}
                onReady={onPlayerReady}
                onStateChange={onPlayerStateChange}
                onError={(e) => console.error("YouTube Player Error:", e)}
                style={{
                  width: '100%',
                  height: '100%',
                  maxWidth: '100%',
                  maxHeight: '100%'
                }}
              />
            </div>
            
            {/* Video Overlay for better visual */}
            <div className="video-overlay"></div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default SpacialExecries;